import { render, staticRenderFns } from "./EventMovieConfiguration.vue?vue&type=template&id=ecbc8f3a&scoped=true&"
import script from "./EventMovieConfiguration.vue?vue&type=script&lang=js&"
export * from "./EventMovieConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./EventMovieConfiguration.vue?vue&type=style&index=0&id=ecbc8f3a&scoped=true&lang=css&"
import style1 from "./EventMovieConfiguration.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbc8f3a",
  null
  
)

export default component.exports